import React from 'react';

const QueryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M24.9999 0C11.2667 0 0.0305176 11.25 0.0305176 25.0002C0.0305176 38.7504 11.2667 50.0004 24.9999 50.0004C38.733 50.0004 49.9692 38.7504 49.9692 25.0002C49.9692 11.25 38.733 0 24.9999 0ZM24.9999 46.8751C12.9834 46.8751 3.15169 37.0312 3.15169 25.0002C3.15169 12.9692 12.9834 3.12488 24.9999 3.12488C37.0164 3.12488 46.848 12.9688 46.848 24.9998C46.848 37.0308 37.0164 46.8751 24.9999 46.8751Z"
          fill="currentColor"
        />
        <path
          d="M23.9935 31.9466C23.4928 31.9466 23.0879 31.5417 23.0879 31.041C23.0879 29.8565 23.2559 28.8333 23.5902 27.9731C23.8355 27.3246 24.2337 26.671 24.7814 26.0108C25.1847 25.5302 25.9071 24.828 26.9521 23.9073C27.9972 22.9849 28.6759 22.2507 28.9901 21.703C29.3043 21.1552 29.4589 20.5571 29.4589 19.9086C29.4589 18.7342 29.0002 17.7043 28.0845 16.8155C27.1689 15.9267 26.0449 15.4832 24.7142 15.4832C23.429 15.4832 22.3554 15.8864 21.4951 16.6912C20.8668 17.2792 20.3947 18.1092 20.0822 19.1811C19.8671 19.917 19.1497 20.3874 18.3886 20.2967C17.4242 20.1825 16.7892 19.2282 17.0647 18.2957C17.4881 16.8626 18.1971 15.7083 19.19 14.8313C20.5694 13.6099 22.394 13 24.6638 13C27.0664 13 28.9834 13.6536 30.4148 14.9624C31.8463 16.2712 32.5603 17.8522 32.5603 19.707C32.5603 20.7806 32.3083 21.7702 31.806 22.6741C31.3036 23.5796 30.3191 24.6801 28.8557 25.9772C27.8728 26.8491 27.2294 27.4926 26.9269 27.9059C26.6245 28.3192 26.4011 28.7947 26.2566 29.3306C26.149 29.7288 26.0751 30.3135 26.0348 31.0813C26.0096 31.5652 25.6081 31.9449 25.1242 31.9449H23.9935V31.9466ZM22.9199 36.2812C22.9199 35.332 23.6894 34.5625 24.6386 34.5625C25.5879 34.5625 26.3574 35.332 26.3574 36.2812C26.3574 37.2305 25.5879 38 24.6386 38C23.6894 38 22.9199 37.2305 22.9199 36.2812Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default QueryIcon;
